/* LDB: show only the playzone layouts that belong to the product's own game.
 *
 * A playmat's artwork decides its trading card game (product metafield
 * custom.tcg), and the brand -> zone-name map lives in the shop metafield
 * custom.playzone_rules. layout/theme.liquid renders the resulting allow list
 * into window.LDB_PLAYZONE_ALLOW for the product being viewed; products with
 * no brand get no allow list at all and keep every zone.
 *
 * Bundle cards filter themselves in Liquid (snippets/bundle-product-card.liquid)
 * because each card is a different product with its own brand -- this file only
 * touches the main product's variant picker, matched on its product id.
 *
 * Metro's variant picker renders either a <select> or a list of radio swatches
 * depending on a theme setting, so both are handled. If the value Shopify
 * pre-selected is one we remove (a Pokémon mat whose default variant is
 * "Yu-Gi-Oh! Zone 1"), the first remaining value is selected and a change event
 * is fired, so Metro resolves the variant, price and URL for what is actually
 * on screen rather than leaving a stale price behind.
 */
(() => {
  const data = window.LDB_PLAYZONE_ALLOW;
  if (!data || !data.allow || !data.productId) return;

  const allow = String(data.allow);
  // Same normalisation as snippets/playzone-allowed.liquid: the catalogue
  // spells these values inconsistently ("Yu-gi-oh! Zone 1", "Pokemon Zone").
  const norm = (value) =>
    String(value == null ? '' : value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]/g, '');
  const allowed = (value) => allow.indexOf(`|${norm(value)}|`) !== -1;
  const isPlayzone = (name) => /playzone/i.test(String(name || ''));

  const valueOf = (el) => el.dataset.optionValue || el.value || el.textContent;

  function pruneSelect(select) {
    const options = [...select.options];
    const keep = options.filter((option) => allowed(valueOf(option)));
    if (!keep.length || keep.length === options.length) return;
    const hadSelection = allowed(select.value);
    options.forEach((option) => {
      if (!allowed(valueOf(option))) option.remove();
    });
    if (!hadSelection) {
      select.value = valueOf(keep[0]);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function pruneSwatches(inputs) {
    const keep = inputs.filter((input) => allowed(valueOf(input)));
    if (!keep.length || keep.length === inputs.length) return;
    const hadSelection = inputs.some((input) => input.checked && allowed(valueOf(input)));
    inputs.forEach((input) => {
      if (allowed(valueOf(input))) return;
      const item = input.closest('li') || input;
      item.remove();
    });
    if (!hadSelection) {
      const first = keep[0];
      first.checked = true;
      const item = first.closest('li');
      if (item) {
        [...item.parentElement.children].forEach((li) => li.classList.remove('active'));
        item.classList.add('active');
      }
      first.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function filter(picker) {
    picker.querySelectorAll('select').forEach((select) => {
      const name = select.getAttribute('name') || select.closest('[data-option-slug]')?.dataset.optionSlug;
      if (isPlayzone(name)) pruneSelect(select);
    });

    const groups = new Map();
    picker.querySelectorAll('input[type="radio"][name]').forEach((input) => {
      if (!isPlayzone(input.name)) return;
      if (!groups.has(input.name)) groups.set(input.name, []);
      groups.get(input.name).push(input);
    });
    groups.forEach((inputs) => pruneSwatches(inputs));
  }

  function run() {
    document
      .querySelectorAll(`variant-selects[data-product-id="${data.productId}"]`)
      .forEach(filter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Metro re-renders the picker when a section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', run);
})();
